const daysOfWeek = [
  { id: 1, name: 'Mo', value: 2 },
  { id: 2, name: 'Di', value: 4 },
  { id: 3, name: 'Mi', value: 8 },
  { id: 4, name: 'Do', value: 16 },
  { id: 5, name: 'Fr', value: 32 },
  { id: 6, name: 'Sa', value: 64 },
  { id: 7, name: 'So', value: 128 },
];

export default daysOfWeek;
